import script from "./ChannelInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChannelInfo.vue?vue&type=script&setup=true&lang=ts"

import "./ChannelInfo.vue?vue&type=style&index=0&id=1cc8ed44&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc8ed44"]])

export default __exports__